import React from 'react';
import './EventoSelecionados.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography, Grid, Container, Button } from '@mui/material';

const EVENT_IMAGE = encodeURI('/media/eventos/Curso de Introducao à Paleografia - Hugo Bizzarri.png');

export default function Paleografia() {
    return (
        <div>
            <div class="TituloEventosSelecionados">
                <div class="row">
                    <Typography
                                                          variant="h4"
                                                          align="center"
                                                          gutterBottom
                                                          style={{
                                                            fontFamily: "'Lato', serif",
                                                            color: "white",
                                                            borderBottom: "4px solid #d4af37",
                                                            paddingBottom: "10px",
                                                            textTransform: "uppercase",
                                                            animation: "glow 2s infinite alternate",
                                                            marginTop: "7%"  // Aqui é onde você define o espaço superior
                                                          }}
                                                        > 
                        <h1>Curso de Introdução à Paleografia</h1>
                        <h1>Ibérica Medieval e Moderna </h1>
                         <h2>O ensino da fé cristã na Península Ibérica.</h2>
                    </Typography>
                </div>
            </div>

            <div className='EventosMov'>
                <div class="container" id='TituloEventosSelecionados'>
                   
                    <div class="row">
                        <div>
                            <div className="titulo-evento">
                                <h1>08 de Agosto</h1>
                                <h6>O curso "Introdução à Paleografia Ibérica Medieval e Moderna" apresentará tipos de letras, bem como abreviações de manuscritos e impressos. Trata-se de orientar o aluno em seus primeiros contatos com o documento.</h6>
                                <h6>O curso será presencial, gratuito, ministrado em língua espanhola e com certificação.</h6>
            
                                 <div class="border"></div>
                            </div>
                        </div>

                     <img className="evento-banner-image" src={EVENT_IMAGE} alt="Curso de Introdução à Paleografia" />
                       
 
                    </div>

                </div>
            </div>
          
        </div>
    )

}
